export default __webpack_public_path__ + "static/media/Inter-Regular.e63a5bf4.woff2";